/**
 * Filters, the open item and the open panel live in the query string, so a link
 * reproduces exactly what the sender saw. This is the one helper for reading
 * and changing them: `set({ status: "failed", page: null })` merges, and an
 * empty value removes the key rather than leaving `?status=`.
 */

import { useCallback } from "react";
import { useSearchParams } from "react-router";

type Patch = Record<string, string | number | null | undefined>;

export function useUrlState() {
  const [params, setParams] = useSearchParams();
  const get = useCallback((key: string) => params.get(key), [params]);
  const set = useCallback(
    (patch: Patch, options: { replace?: boolean } = {}) =>
      setParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          for (const [key, value] of Object.entries(patch)) {
            if (value === null || value === undefined || value === "") next.delete(key);
            else next.set(key, String(value));
          }
          return next;
        },
        { replace: options.replace ?? false },
      ),
    [setParams],
  );
  return { get, set, params };
}
